import { ControlLayout } from 'components/ControlLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import { SimulationCard } from 'components/simulation/SimulationCard';
import { useContext, useEffect, useState } from 'react';
import checkIsMobile from 'utils/CheckIsMobile';
import InfoIcon from '@material-ui/icons/Info';
import { AlertInfo } from 'components/simulation/AlertInfo';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from 'hooks/useQueryParams';
import { getCurrencyFormat } from 'utils/getCurrencyFormat';
import { DATA_LAYERS, DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import {
	RESPONSE_PATH,
	RESPONSE_VIEW_ERROR,
	RESPONSE_VIEW_LO_SENTIMOS_RESIMULACION,
} from 'constants/ResponseType';
import { LoanControllerApi, LoanDto, LoanDtoActionIdEnum } from 'client';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';
import { AuthServicesImpl } from 'services/auth/AuthServicesImpl';
import { LoadingModal } from 'components/response/LoadingModal';
import { InfoModal } from 'components/modals/InfoModal';
import TagManager from 'react-gtm-module';
import { setHashedEmailInStorage } from 'utils/setHashedEmailInStorage';
import { useControlModal } from 'hooks/useControlModal';
import { LoandingContext } from 'context/LoandingContext';

export const SimulationContainer = () => {
	const [showLoadingModal, setShowLoadingModal] = useState(false);
	const query = useQueryParams() as any;
	const history = useHistory();
	const classContainer = checkIsMobile()
		? 'portabilidad-container'
		: 'portabilidad-container card-box';

	const { open, handleClose } = useControlModal(true);
	const { setLoading } = useContext(LoandingContext);

	useEffect(
		() => {
			if (query.resimulation) {
				handleClose();
			}
			sessionStorage.setItem('original-simulation', JSON.stringify(query));
			setShowLoadingModal(true);
			const authService = new AuthServicesImpl();
			authService
				.login()
				.then((tokenResponse) => {
					const { token } = tokenResponse.data;
					sessionStorage.setItem('session', JSON.stringify({ token: `Bearer ${token}` }));
					setShowLoadingModal(false);
				})
				.catch((_: any) => {
					history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
				});
		},
		//eslint-disable-next-line
		[]
	);

	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SIMULACION),
			});
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div className={classContainer} style={{ overflow: 'hidden' }}>
			{query.isFromLoan ? null : (
				<InfoModal
					open={open}
					toggleModal={handleClose}
					title="Bienvenido al flujo de autoatención"
					content={
						<>
							<p>
								A continuación podrás ver la{' '}
								<span style={{ fontWeight: 'bold' }}>
									simulación de cuota del crédito que solicitaste.
								</span>
							</p>
							<p className="primary-color" style={{ fontWeight: 'bold', marginTop: 24 }}>
								Autogestionar tu crédito es:
							</p>
							<ul style={{ marginLeft: 24, marginTop: 16 }}>
								<li>
									<span className="primary-color" style={{ fontWeight: 'bold' }}>
										Rápido
									</span>
									, porque te evaluamos antes de que te llame un ejecutivo
								</li>
								<li>
									<span className="primary-color" style={{ fontWeight: 'bold' }}>
										Conveniente
									</span>
									, porque te damos un descuento en tu tasa.
								</li>
							</ul>
							<p style={{ fontWeight: 'bold', marginTop: 24 }}>Debes tener a mano:</p>
							<ul style={{ marginLeft: 24, marginTop: 16 }}>
								<li>3 últimas liquidaciones de sueldo </li>
								<li>Certificado de últimas 12 cotizaciones de AFP</li>
								<li>1 comprobante de domicilio</li>
							</ul>
						</>
					}
					buttonLabel="Entendido"
				/>
			)}
			<LoadingModal showLoadingModal={showLoadingModal} />
			<MultiFormCardHeader
				title={`¡${query.name ? query.name + ' revisa tu simulación!' : 'Revisa tu simulación!'} `}
				body={
					<>
						Para financiar tu vehículo de{' '}
						<b>{getCurrencyFormat(Number.parseInt(query.vehicleValue))}</b>
					</>
				}
			/>
			<SimulationCard data={query} />
			<p className="body-small gris-6" style={{ marginTop: 16 }}>
				<b>* CAE: Carga anual equivalente,</b> incluye los intereses, gastos y seguros asociados al
				crédito expresados en forma anual.
			</p>
			{/*
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-around',
					alignItems: 'center',
					backgroundColor: '#00a9e3',
					color: 'white',
					position: 'relative',
					left: '-56px',
					width: '100%',
					marginTop: '16px',
					padding: '16px 56px',
				}}
				className="body-bold"
			>
				<p style={{ flex: 1 }}>¿No estas conforme con tu cuota?</p>{' '}
				<Button
					variant="outlined"
					style={{ color: 'white', flex: 1, borderColor: 'white' }}
					onClick={() => {
						history.push('/nueva-simulacion');
					}}
				>
					Vuelve a simular
				</Button>
			</div>

			{isHasDiscount.current ? (
				<>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							backgroundColor: '#004e9c',
							color: 'white',
							position: 'relative',
							left: '-56px',
							width: '100%',
							margin: '16px auto 8px',
							padding: '16px 56px',
						}}
						className="title-4"
					>
						<p>20% de descuento en la tasa*</p>
						<p
							style={{
								color: '#F9E20D',
							}}
						>
							Sólo hasta el 26 de mayo
						</p>
					</div>
					<p
						style={{
							textAlign: 'center',
						}}
						className="small primary-color"
					>
						*El descuento se aplicará sobre la tasa de interés mostrada en la simulación
					</p>
				</>
			) : null}
			*/}

			<AlertInfo
				icon={<InfoIcon color="secondary" style={{ fontSize: 24 }} />}
				content={
					<>
						El monto simulado <span className="primary-color">no implica una aprobación</span> y
						queda sujeto a evaluación de riesgo
					</>
				}
				margin="40px auto"
			/>

			<ControlLayout
				inputError={false}
				disableBackButton={false}
				handleBackClick={() => {
					window.location.href = `${process.env.REACT_APP_WORDPRESS_URL} `;
				}}
				handleNextClick={() => {
					setLoading(true);
					const loanDto: LoanDto = {
						...query,
						firstName: query.name,
						actionId: LoanDtoActionIdEnum.UpdateLoanLead,
						downPayment: Number.parseInt(query.downPayment),
						salary: Number.parseInt(query.salary),
						vehicleValue: Number.parseInt(query.vehicleValue),
						vehicleYear: Number.parseInt(query.vehicleYear),
						loanInstallmentNumber: Number.parseInt(query.installmentNumber),
						discountInterestRate: Number.parseFloat(query.discountInterestRate.replace(',', '.')),
						simulation: sessionStorage.getItem('new-simulation')
							? JSON.parse(sessionStorage.getItem('new-simulation') as string)
							: null,
					};

					setHashedEmailInStorage(query.email);

					setShowLoadingModal(true);
					const loanController = new LoanControllerApi();
					if (query.isFromLoan) {
						history.push(`/subida-archivos/${query.crmIdentifier}`);
					} else {
						loanController
							.createLoanLeadUsingPOST(getTokenFromStorage(), loanDto)
							.then((response) => {
								if (query.resimulation === undefined) {
									history.push(`/subida-archivos/${query.crmIdentifier}`);
									return;
								}

								if (
									null != response.data &&
									null != response.data.scoring &&
									null != response.data.scoring.color
								) {
									if (
										response.data.scoring.color === 'Verde' ||
										response.data.scoring.color === 'Amarillo'
									) {
										history.push(`/subida-archivos/${query.crmIdentifier}`);
									} else {
										history.push(
											`${RESPONSE_PATH}/${RESPONSE_VIEW_LO_SENTIMOS_RESIMULACION}/resimula`
										);
									}
								} else {
									history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
								}
							})
							.catch(() => {
								history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
							});
					}
				}}
				buttonBackName={'Salir'}
				buttonNextName={'¡Lo quiero!'}
			/>
		</div>
	);
};
